import { BrowserRouter, Route, Routes as Router } from "react-router-dom";

import { DefaultLayout, EmptyLayout } from "layouts";
import { Error, Handler } from "components";
import {
  Community,
  Feedback,
  ForgotPassword,
  Home,
  Invitee,
  Inviter,
  ManagePotluck,
  ResetPassword,
  SignIn,
  Summary,
  UserContributor,
  UserDashboard,
  UserGuestOnboarding,
  UserOnboarding,
  Voting,
} from "pages";
import { Routes } from "utils";
import { NavigationProvider, useSession } from "contexts";
import { Protected } from "middlewares";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const { isAuthenticated } = useSession();

  return (
    <BrowserRouter>
      <NavigationProvider>
        <Router>
          <Route path={Routes.home} element={<DefaultLayout />}>
            <Route index element={<Home />} />
            <Route path={Routes.community} element={<Community />} />
            <Route path={Routes.feedback} element={<Feedback />} />
            <Route path={Routes.createnew} element={<Inviter />} />
            <Route path={Routes.contribute} element={<Invitee />} />
            <Route
              path={Routes.usercontributor}
              element={<UserContributor />}
            />
            <Route
              path={Routes.userdashboard}
              element={
                <Protected
                  condition={!isAuthenticated}
                  redirectTo={Routes.home}
                >
                  <UserDashboard />
                </Protected>
              }
            />
            <Route path={Routes.managepotluck} element={<ManagePotluck />} />
            <Route path={Routes.voting} element={<Voting />} />
            <Route path={Routes.summary} element={<Summary />} />
          </Route>

          <Route
            path={Routes.auth}
            element={
              <Protected condition={isAuthenticated} redirectTo={Routes.home}>
                <DefaultLayout />
              </Protected>
            }
          >
            <Route index path={Routes.login} element={<SignIn />} />
            <Route path={Routes.useronboarding} element={<UserOnboarding />} />
            <Route
              path={Routes.userguestonboarding}
              element={<UserGuestOnboarding />}
            />
            <Route path={Routes.accountrecovery} element={<ForgotPassword />} />
            <Route path={Routes.forgotpassword} element={<ForgotPassword />} />
          </Route>

          <Route path={Routes.auth} element={<DefaultLayout />}>
            <Route path={Routes.resetpassword} element={<ResetPassword />} />
          </Route>

          <Route path={Routes.handler} element={<EmptyLayout />}>
            <Route path={Routes.share} element={<Handler.Share />} />
            <Route path={Routes.guest} element={<Handler.Guest />} />
          </Route>

          <Route path="*" element={<Error.Error404 />} />
        </Router>
      </NavigationProvider>
    </BrowserRouter>
  );
};
